export default {
    tabs: [],
}
